import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';

/**
 * Button to redirect to chargify payment page
 */
class SubscriptionPaymentInfo extends Component {
  render() {
    const {
      subscription,
      handlePaymentInfo
    } = this.props;

    const hasPaymentInfo = subscription.hasPaymentInfo;

    return (
      <Button
        color="primary"
        size="medium"
        onClick={_ => handlePaymentInfo({ subscription })}
      >
        {
          hasPaymentInfo
            ? <FormattedMessage id='subscription.button.updatePaymentInfo' />
            : <FormattedMessage id='subscription.button.setPaymentInfo' />
        }
      </Button>
    );
  }
}

SubscriptionPaymentInfo.propTypes = {
  subscription: PropTypes.object.isRequired,
  handlePaymentInfo: PropTypes.func.isRequired
}

export default SubscriptionPaymentInfo;


// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionPaymentInfo.js